<template>
    <nav-bar :returnAction="true" :pageName="'Notificação'" @return="$router.push('/appNotifications')" />
    <main-container :onlyNav="true">
        <div class="row w-100">
            <div class="col-sm-12 d-flex">                
                <label for="recipient-name" class="col-form-label fw-bold fs-3">{{appNotification.title}}</label>                                
            </div>                   
            <div class="col-sm-12">
                <label for="recipient-name" class="col-form-label no-padding-bottom">{{`Data: ${formatFullDate(appNotification.createdAt)}`}}</label>                
            </div>                        
            <div class="col-sm-12 mb-1 fw-bold">                
                <label for="col-form-label">Mensagem</label>                                
                <textarea class="form-control textarea" id="exampleFormControlTextarea1" v-model="appNotification.message" disabled></textarea>
            </div>
        </div>
    </main-container>    
</template>


<script>
import { getInstance } from "../../api/api";
import { showErrorModal } from "../../services/popups";
import {formatFullDate}  from "../../services/formatters";
import { useUserStore } from '@/store/user';
const api = getInstance();

export default {
    name: "AppNotificationReadingView",
    inject:["mySpinner"],
    setup() {
        const userStore = useUserStore();

        return { userStore }
    },
    async mounted() {
        if (!this.appNotificationId) {return;}
        await this.getAppNotificationById(this.appNotificationId);
        if (!this.appNotification.viewingDate) {
            await this.visualizeAppNotification(this.appNotificationId);
        }
    },
    props: {
        appNotificationId: {
            type: String
        }
    },
    data() {
        return {
            appNotification: {}
        }
    },
    methods: {
        cleanFields() {
            this.appNotification = {
                id:"",
                title:"",
                message:"",
                createdAt:""
            }
        },
        async getAppNotificationById(id) {
            try {
                this.mySpinner.loading = true;

                let response = await api.get("v1/AppNotifications/Id", {params:{appNotificationId:id}})

                this.mySpinner.loading = false;

                if (!response.data.success) {
                    showErrorModal(response.data.message);
                }
                else {
                    this.appNotification = response.data.data;
                }
                
            } catch {
                this.mySpinner.loading = false;                
            }
        },
        async visualizeAppNotification() {
            try {
                this.mySpinner.loading = true;

                let response = await api.post("v1/AppNotifications", {appNotificationId:this.appNotificationId})

                this.mySpinner.loading = false;

                if (!response.data.success) {
                    showErrorModal(response.data.message);
                }
                else {
                    this.userStore.readNotification();
                }
                
            } catch {
                this.mySpinner.loading = false;                
            }
        },
        formatFullDate    
    },
}
</script>
